// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"46e21837","453":"68d2f560","732":"f93fc04e"}[chunkId] + ".chunk.js";
};